// Recuerda, solo en este navegador/dispositivo, si ya se registró o usó una
// llave de acceso alguna vez (y con qué emails). No hay forma de preguntarle
// esto al backend sin revelar si un email tiene passkey (ver el comentario
// sobre enumeración en generatePasskeyLoginOptions), así que la señal es
// puramente local: sirve para decidir qué pantalla de login mostrar, nunca
// para saltarse la verificación real — la ceremonia WebAuthn de verdad la
// sigue haciendo el navegador/SO en cada intento.
const STORAGE_KEY = 'notiline_passkey_emails';

function normalize(email) {
  return String(email || '').trim().toLowerCase();
}

function readEmails() {
  try {
    const raw = window.localStorage.getItem(STORAGE_KEY);
    const list = raw ? JSON.parse(raw) : [];
    return Array.isArray(list) ? list : [];
  } catch {
    return [];
  }
}

function writeEmails(list) {
  try {
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
  } catch {}
}

// Alcanza con que el dispositivo tenga UNA llave de acceso usada, de
// cualquier cuenta: el propio selector de passkeys del navegador/SO ya sabe
// distinguir entre varias cuentas registradas ahí (para eso es "usernameless").
export function deviceHasAnyPasskeyRemembered() {
  return readEmails().length > 0;
}

export function rememberPasskeyForEmail(email) {
  const normalized = normalize(email);
  if (!normalized) return;
  const emails = readEmails().filter((e) => e !== normalized);
  writeEmails([normalized, ...emails]);
}

export function forgetPasskeyForEmail(email) {
  const normalized = normalize(email);
  if (!normalized) return;
  writeEmails(readEmails().filter((e) => e !== normalized));
}
